module.exports = __webpack_public_path__ + "img/app.bbf3261f.png";